const fetchData = (pageId: number): string => `
    {
        latestContentByInterests {
          id
          title
          type
          uri
          link
          description
          date
        }
        
        page(id: "${pageId}", idType: DATABASE_ID) {
            PostLoginPage {
              interestsSliderTitle
              interestsSliderDescription
            }
      }
  }
`;
export default fetchData;
